var collapsible_list_component_rtlignore_default = {
  "ltr": "vTIkP",
  "rtl": "Gf-5e",
  "iconContainer": "WGMxA",
  "icon": "_7SFid",
  "isExpanded": "dKsuv",
  "listDimensions": "GGrrO"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
